<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="1300_auto"
      :footer="false">
    <template #header>
      <span>操作日志</span>
    </template>

    <template #content>
      <app-base-main
          no-padding
          :table-shadow="false">
        <template #filter-group>

          <app-filter-group @query="$gjNoticeQuery" :reset="false" :isBr="false">

            <gj-country-server-select
                v-model="filter.countryIdList"
                :width="['140px', '170px']"
            ></gj-country-server-select>


            <div class="flex align-center size12" style="margin-left: 14px!important;">数据日期:</div>
            <gj-date-picker
                v-model="filter.recordDate"
                type="daterange"
                startPlaceholder="开始日期"
                endPlaceholder="结束日期"
            ></gj-date-picker>

            <div class="flex align-center size12" style="margin-left: 14px!important;">操作时间:</div>
            <gj-date-picker
                v-model="filter.operateDate"
                type="daterange"
                startPlaceholder="开始日期"
                endPlaceholder="结束日期"
            ></gj-date-picker>

            <gj-input
                v-model="filter.keyword"
                placeholder="输入报表名称、操作用户"
                width="200px"
            ></gj-input>

          </app-filter-group>

        </template>

        <template #table>
          <gj-table
              ref="gjTable"
              :index="false"
              :data="tableData"
              :columns="columns"
              :loading="loading"
              :adapt-height="false"
              :height="500"
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery"
          >
            <template v-slot:attachmentSizeText="{row}">
              {{row.attachmentSizeText}}
              <template v-if="row.attachmentId==='0'||isMeaningless(row.attachmentId)">-</template>
              <gj-button v-else type="text" :loading="row.downLoad" @click="logDownLoad(row)">下载</gj-button>
            </template>

          </gj-table>
        </template>

      </app-base-main>

    </template>
  </gj-modal>
</template>

<script>

import {isMeaningful, isMeaningless} from "@/utils/common";
import {isMeaningfulMixin, queryMixin, selectionMixin, modalMixIn} from "@/minxins";
import {convertToDate, convertToMonth} from "@/utils/date.util";
import {businessLog, businessLogDownload} from "@/api/statistics";
import {exportFile} from "@/api/common";
import {mapGetters} from "vuex";

export default {
  name: "log-modal",
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin, modalMixIn],
  props: {
    id: null
  },
  computed: {
    ...mapGetters(['marketOption']),
  },
  data() {
    return {
      loading: false, // 加载
      tableData: [], // 表格数据
      filter: {
        countryIdList: {},// 国家、店铺
        recordDate: [],// 数据日期
        keyword: null,// 查询关键字：报表名称或者操作用户
        operateDate: [],// 操作时间
      },
      columns: [
        {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '140px', options: () => this.marketOption},
        {id: 'recordDate', header: '数据日期', field: 'recordDate', width: '140px', sortable: true},
        {id: 'operationTypeName', header: '操作类型', field: 'operationTypeName', width: '120px'},
        {id: 'operationTcontent', header: '操作内容', field: 'operationTcontent', minWidth: '220px', overflowLine: 1},
        {id: 'attachmentSizeText', header: '文件下载', field: 'slot:attachmentSizeText', width: '160px'},
        {id: 'operationUser', header: '操作用户 ', field: 'operationUser', width: '120px'},
        {id: 'createTime', header: '操作时间', field: 'createTime', width: '160px', sortable: true},
      ],
    }
  },
  methods: {
    isMeaningless,
    async $gjQuery() {
      this.loading = true
      let params = {
        model: {
          ...this.filter,
          countryIdList: this.filter.countryIdList.countryIds || [],//国家编码集合
          marketIdList: this.filter.countryIdList.marketIds || [],//店铺id集合
          startOperateDate: this.filter.operateDate?convertToDate(this.filter.operateDate[0]):'',//开始时间
          endOperateDate: this.filter.operateDate?convertToDate(this.filter.operateDate[1]):'',//结束时间
          startRecordDate: this.filter.recordDate?convertToDate(this.filter.recordDate[0]):'',
          endRecordDate: this.filter.recordDate?convertToDate(this.filter.recordDate[1]):'',
          businessReportLogId: this.id,
        },
        ...this.queryPagination,
        ...this.querySort
      };
      try {
        let data = await businessLog(params) || {};
        this.pagination = this.getPagination(data);
        this.tableData = data.records.map(r => {
          return {
            ...r,
            downLoad:false
          }
        })
      } finally {
        this.loading = false
      }
    },
    logDownLoad(row){
      row.downLoad = true;
      businessLogDownload({idList:[row.id]}).then(data=>{
        exportFile(`/file/attachment/download`, data).then(res=>{
          this.$gjResetPage()
        })
            .complete(() => {row.downLoad = false;});
      })
    }
  }
}
</script>

<style scoped>

</style>